// src/pages/Moderation/ModerationQueuePage/ui/ReportsTable/ReportsTableHeader.tsx
import React from 'react';

export const ReportsTableHeader: React.FC = () => {
  return (
    <div className="reports-table__header">
      <div className="reports-table__col reports-table__col--id">Report</div>
      <div className="reports-table__col reports-table__col--restricted">Restricted</div>
      <div className="reports-table__col reports-table__col--restriction">Restriction</div>
      <div className="reports-table__col reports-table__col--channel">Channel</div>
      <div className="reports-table__col reports-table__col--user">User</div>
      <div className="reports-table__col reports-table__col--message">Message</div>
      <div className="reports-table__col reports-table__col--created">Created</div>
      <div className="reports-table__col reports-table__col--actions">Actions</div>
    </div>
  );
};
